import {vacinasCovid} from './VacinasCovid';
import {causa} from './Causa';
import {vacinas} from './Vacinas';
import {ciclo} from './Ciclo';
import {sintomas} from './Sintomas';
import {prevencao} from './Prevencao';

function useGetData(puzzle){
  switch (puzzle) {
    case "vacinascovid19":
      return vacinasCovid();
    case "causa":
      return causa();
    case "ciclo":
      return ciclo();
    case "sintomas":
      return sintomas();
    case "vacinas":
      return vacinas();
    case "prevencao":
      return prevencao();
    default:
      return false;
  }
}

export{useGetData};
